module.exports = __webpack_public_path__ + "static/hiking_mountain-9209db273b8f132a008d81571aed1798.svg";